// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"08b3bbfd","451":"496514f4","453":"91cec25e","626":"7e177fcb"}[chunkId] + ".chunk.js";
};